import { useQuery } from '@apollo/client';
import React, { ComponentProps } from 'react';
import ErrorMessage from '../../ErrorMessage';
import GET_ADMINISTRATORS from './getAdministrators';
import { captureApolloError } from 'util/apolloError';
import { OptionType } from 'components/Dropdown';
import FilterDropdown from 'system/data/FilterDropdown';
import {
  AdministratorsQuery,
  AdministratorsQueryVariables,
} from 'types/graphql';
import { ID, matchNodes } from 'util/localTypes';
import Spinner from 'system/elements/Spinner';

type Props = object &
  AdministratorsQueryVariables &
  Omit<ComponentProps<typeof FilterDropdown>, 'options'>;

const AssignedAdminFilterDropdown = ({ organizationId, ...props }: Props) => {
  const { data, loading, error } = useQuery<
    AdministratorsQuery,
    AdministratorsQueryVariables
  >(GET_ADMINISTRATORS, {
    variables: { organizationId },
  });

  const baseOptions: OptionType<null | undefined | ID>[] = [
    { label: 'All Administrators', value: undefined },
    { label: 'Unassigned', value: null },
  ];

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    captureApolloError(error);
    return <ErrorMessage>{error.message}</ErrorMessage>;
  }

  const options = baseOptions.concat(
    matchNodes(
      data?.organization,
      'Organization',
      (o) => o.administrators.nodes
    ).map((admin) => ({
      label: admin.name,
      value: admin.id,
    }))
  );

  return <FilterDropdown {...props} options={options} />;
};

export default AssignedAdminFilterDropdown;
